<template>
  <div>
    <label v-if="label" class="mr-1 mb-2 text-size-14 text-mild">{{
      label
    }}</label>
    <AppLabel :variant="appLabelVariant">{{ appLabelText }}</AppLabel>
    <p class="text--gray--">{{ description }}</p>
    <AppTextField
      :id="id"
      :value="value"
      :type="type"
      :validation-state="validationState"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :formatter="formatter"
      :inputmode="inputmode"
      :maxlength="maxlength"
      @focus="onFocus"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
    />
    <FormInvalidFeedback
      v-if="validationState"
      :validation-state="validationState"
      :state="false"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppTextField from "@/components/atoms/input/AppTextField.vue";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import AppLabel from "@/components/atoms/input/AppLabel.vue";

type ValidationStateType = {
  validated: boolean;
  valid: boolean | undefined;
  handleChange?: (value: unknown, shouldValidate?: boolean) => void;
};

@Component({
  components: {
    AppTextField,
    FormInvalidFeedback,
    AppLabel
  }
})
export default class TextFieldGroup extends Vue {
  @Prop({
    validator: prop =>
      typeof prop === "string" || typeof prop === "number" || prop === null,
    required: true,
    default: ""
  })
  value!: string | number | null;

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: String,
    default: "red"
  })
  appLabelVariant!: string;

  @Prop({
    type: String,
    default: ""
  })
  placeholder!: string;

  @Prop({
    type: String,
    default: "text"
  })
  type!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  readonly!: boolean;

  @Prop({
    validator: prop => typeof prop === "function" || prop === null,
    default: null
  })
  formatter!: () => {};

  @Prop({
    type: Object,
    default: null
  })
  validationState!: ValidationStateType;

  @Prop({
    type: String,
    default: ""
  })
  description!: string;

  @Prop({
    type: String,
    default: ""
  })
  id!: string;

  @Prop({
    type: String,
    default: null
  })
  inputmode!: string | null;

  @Prop({
    type: Number,
    default: null
  })
  maxlength!: number | null;

  onFocus() {
    this.$emit("focus");
  }

  onInput(v: string) {
    this.$emit("input", v);
  }

  onBlur(v: string) {
    this.$emit("blur", v);
  }

  onChange(v: string) {
    this.$emit("change", v);
  }
}
</script>
